import { useMemo } from "react";

const DIGIT_PLACEHOLDER = "_";

export function formatWithMask(value: string, mask: string): string {
    const digits = value.replace(/\D/g, "");
    let out = "";
    let d = 0;
    for (let i = 0; i < mask.length && d < digits.length; i++) {
        if (mask[i] === DIGIT_PLACEHOLDER) {
            out += digits[d];
            d++;
        } else {
            out += mask[i];
        }
    }
    return out;
}

export function parseDigits(value: string): string {
    return value.replace(/\D/g, "");
}

export function isEmptyMask(mask: string): boolean {
    return mask.split("").every((char) => char === DIGIT_PLACEHOLDER);
}

export type UsePhoneMaskProps = {
    mask: string;
};

export function usePhoneMask({ mask }: UsePhoneMaskProps) {
    const hasEmptyMask = useMemo(() => isEmptyMask(mask), [mask]);
    return { hasEmptyMask };
}
